
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","stroke":"currentColor","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.927 13.043L2.25 11.78c-.842-.402-.842-1.548 0-1.937l8.77-4.134a1.15 1.15 0 011.003 0l8.77 4.134c.843.401.843 1.547 0 1.937l-2.823 1.334","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.521 16.56l-.644-.142c-.842-.178-2.18.141-3.183.46a4.512 4.512 0 01-2.738 0c-1.003-.319-2.341-.638-3.184-.46l-.644.141c-.619.13-1.201-.319-1.201-.921v-2.894c0-.437.322-.826.768-.921a27.002 27.002 0 0111.26 0 .949.949 0 01.768.921v2.894c0 .602-.582 1.051-1.202.921zM21.427 10.41v5.149M20.987 19h1.026c.542 0 .987-.239.987-.53v-1.94c0-.291-.445-.53-.987-.53h-1.026c-.542 0-.987.239-.987.53v1.94c0 .291.445.53.987.53z","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    